import React from "react"
import { connect } from 'react-redux'

import { reorderable } from '../../shared/components/reorderable.jsx'
import EditableSurveySection from './editable_survey_section.jsx'

import { reorderSection, setTypeOfThingDragging, clearTypeOfThingDragging  } from '../ducks/survey.js'

let DraggableSurveySection = reorderable(EditableSurveySection, 'DraggableSurveySection', {
  moveHandlerName:      '_reorderSection',
  beginDragHandlerName: 'handleBeginDrag',
  endDragHandlerName:   'handleEndDrag',
  clearDragTypeHandlerName: 'handleClearDragType',

  validDropTarget: (targetProps, sourceProps) => {
    return targetProps.surveyId === sourceProps.surveyId
  }
})

DraggableSurveySection = connect(
  null,
  (dispatch, props) => ({
    _reorderSection: (source, target) => {
      dispatch(reorderSection(source, target))
    },
    handleBeginDrag: (dragType) => {
        console.log('handleBeginDrag called with:', dragType);
        const action = setTypeOfThingDragging(dragType);
        dispatch(action);
    },
    handleEndDrag: () => {
        console.log('handleEndDrag called');
    },
    handleClearDragType: () => {
        console.log('handleClearDragType called');
        dispatch(clearTypeOfThingDragging());
    }
  })
)(DraggableSurveySection)

export default React.forwardRef((props, ref) => {
  return <DraggableSurveySection { ...props } forwardedRef={ ref } />
});
